"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _focus = require("@react-aria/focus");
var _Icon = require("../../media/icon/Icon");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _input = require("../../../components/inputs/input/input.tokens");
var _InfoDisplayWrapper = require("../../../shared/utility-components/InfoDisplayWrapper");
var _jsxRuntime = require("react/jsx-runtime");
var spacing = _tokens.default.sky.sys.spacing;
var size = _tokens.default.sky.sys.size;
var DropDownButtonField = _styledComponents.default.button.withConfig({
  displayName: "ButtonDropdownField__DropDownButtonField",
  componentId: "sc-48a4sx-0"
})(["&[data-state='open']{svg.right-icon{transform:rotate(-180deg);}}cursor:pointer;display:flex;align-items:center;justify-content:space-between;height:", ";width:", ";padding:", " ", ";margin:2px 0;background-color:", ";border:", " solid ", ";border-radius:", ";", ";-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;outline:none;color:", ";&:active,&.focus-ring{padding:", " calc(", " - ", " + ", ");border:", " solid ", ";}&.focus-ring{box-shadow:", ";}", " ", ""], function (_ref) {
  var height = _ref.height;
  return _input.tokens.size.height[height];
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, spacing['200'], spacing['400'], _tokens.default.sky.sys.color.background.neutral['1'], size.borderwidth.thin, _tokens.default.sky.sys.color.border.enabled, size.borderradius['2'], _tokens.default.sky.sys.font.body['1'], function (_ref3) {
  var isDefaultLabel = _ref3.isDefaultLabel;
  return isDefaultLabel ? _tokens.default.sky.sys.color.text.content.auxiliary : _tokens.default.sky.sys.color.text.content.main;
}, spacing['200'], spacing['400'], size.borderwidth.thick, size.borderwidth.thin, size.borderwidth.thick, _tokens.default.sky.sys.color.border.active, _tokens.default.sky.sys.elevation.shadow.focusring, function (_ref4) {
  var hasError = _ref4.hasError;
  return hasError && (0, _styledComponents.css)(["border:", ";"], _input.tokens.border.error);
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && (0, _styledComponents.css)(["pointer-events:none;background-color:", ";border:", ";"], _input.tokens.color.background.disabled, _input.tokens.border.disabled);
});
var ButtonDropdownField = /*#__PURE__*/_react.default.forwardRef(function (_ref6, ref) {
  var _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? _input.TextFieldSize.LARGE : _ref6$size,
    _ref6$width = _ref6.width,
    width = _ref6$width === void 0 ? '100%' : _ref6$width,
    disabled = _ref6.disabled,
    hasError = _ref6.hasError,
    children = _ref6.children,
    onClick = _ref6.onClick,
    isDefaultLabel = _ref6.isDefaultLabel,
    errorText = _ref6.errorText,
    props = _objectWithoutProperties(_ref6, ["size", "width", "disabled", "hasError", "children", "onClick", "isDefaultLabel", "errorText"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoDisplayWrapper.InfoDisplayWrapper, {
    errorText: errorText,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
      focusRingClass: "focus-ring",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(DropDownButtonField, _objectSpread({}, props, {
        disabled: disabled,
        width: width,
        height: size,
        hasError: hasError,
        ref: ref,
        isDefaultLabel: isDefaultLabel,
        children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          className: 'right-icon',
          icon: 'chevronDown'
        })]
      }))
    })
  });
});
var _default = exports.default = ButtonDropdownField;